import { combineReducers, configureStore } from '@reduxjs/toolkit'
import accountReducer from './accountReducer'
import listReducer from './listReducer'
import homeReducer from './homeReducer'
import userReducer from "./userReducer";

const rootReducer = combineReducers({
    accountReducer,
    listReducer,
    homeReducer,
    userReducer,
})

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
})

export default store
